import { SlidersHorizontalIcon as PhosphorSlidersHorizontalIcon } from "@phosphor-icons/react/dist/ssr/SlidersHorizontal";

import { createAppIcon } from "@/components/createAppIcon";

export const FilterSettingsIcon = /* @__PURE__ */ createAppIcon(PhosphorSlidersHorizontalIcon);
